import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import React from 'react'

import { INVOICE_STATUS, INVOICE_STATUS_DISPLAY } from 'settings/constants/invoice'

const { NOT_READY_FOR_INVOICE, READY_FOR_INVOICE } = INVOICE_STATUS
const CHIP_SX = { color: 'background.paper', width: 12, height: 12 }

type Props = {
  status?: string | null
  label?: string
}

const WorkOrderInvoiceStatusChip: React.FC<Props> = ({ status, label }) => {
  const display = status ? INVOICE_STATUS_DISPLAY[status as keyof typeof INVOICE_STATUS_DISPLAY] : undefined
  const getInvoiceStatusChipIcon = () => {
    if (status === NOT_READY_FOR_INVOICE) return <CloseIcon sx={CHIP_SX} />
    if (status === READY_FOR_INVOICE) return <CheckIcon sx={CHIP_SX} />
    // INVOICED
    return <TaskOutlinedIcon sx={CHIP_SX} />
  }

  return (
    <Chip
      avatar={<Avatar sx={{ backgroundColor: 'background.black', opacity: 0.38 }}>{getInvoiceStatusChipIcon()}</Avatar>}
      label={label || display?.title}
      size="small"
      sx={{ backgroundColor: display?.bgColor }}
    />
  )
}

export default WorkOrderInvoiceStatusChip
